import axios from "axios";
import * as Sentry from '@sentry/vue';

const user = {
  namespaced: true,
  state: {
    user: null
  },
  getters: {
    user({ user }) {
      return user;
    },
    canEditKeywords({ user }) {
      return user?.permissions?.keywords_permission === 'EDIT';
    },
    canEditCompetitors({ user }) {
      return user?.permissions?.competition_permission === 'EDIT';
    },
    canEditLocation({ user }) {
      return user?.permissions?.local_permission === 'EDIT';
    },
    hasOrganisationPermissions({ user }) {
      return user?.permissions?.organisation_permission === 'EDIT';
    },
    isAdmin({ user }) {
      return ['ADMIN', 'DEVELOPER'].includes(user?.user_type);
    },
    isDeveloper({ user }) {
      return user?.user_type === 'DEVELOPER';
    },
    hasOptimizerAccessPermission({ user }) {
      return user?.permissions?.optimiser_access;
    },
    requestedOptimiserInstallationForActiveWebsite({ user }) {
      return user?.active_website.requested_optimiser_installation;
    },
    activeWebsiteIsFreeAppsumo({ user }) {
      return user?.active_website.appsumo_code !== null;
    },
  },
  mutations: {
    async setUser(state, {user}){
      Sentry.setUser({
        id: user.id,
        email: user.email,
      });
      state.user = user;
    },
  },
  actions: {
    getUser: ({commit}) =>
      axios.get(`/ajax/reports/get-user`)
        .then(({data}) => commit('setUser', {user: data.user})),
    fetchUser: ({commit}) =>
      axios.get('/user/fetch-data')
        .then(({data}) => commit('setUser', {user: data.user})),
    turnOffMismatchWarning: ({commit}) =>
      axios.get('/user/turn-off-mismatch-warning')
        .then(({data}) => commit('setUser', {user: data.user})),
    updateTermsOfService: ({dispatch}) =>
        axios.put('/organisation/terms-of-service', { accepted: true })
        .finally(() => dispatch('getUser'))
  }
};

export default user;
